/**
 * 参数说明
 * @param disable
 * @param appId  小程序appId
 * @param channel 如果是推栏的小程序需要携带channel=jhdaily
 * @param username 小程序原始id,例如:gh_bb1a8b842018
 * @param path 小程序打开h5页面的路径,例如:pages/webview/index
 * @param webviewUrlTag 小程序webview打开h5页面链接参数标识,例如:redirectUrl
 * @param redirectUrl 小程序webview打开的h5页面链接
 * @param isMaster 是否是正式环境,因为url-schema接口区分正式接口和测试接口
 * @param envVersion 小程序环境版本 release:正式环境 trial:体验版
 * @constructor
 */
export default function RedirectMiniprogramAccess({ disable, appId, channel, username, path, webviewUrlTag, redirectUrl, isMaster, envVersion }) {
  if (disable) {
    return null;
  } else if (!appId) {
    throw new Error('需传入appId');
  } else if (!username) {
    throw new Error('需传入username');
  } else if (!path) {
    throw new Error('需传入path');
  }

  const scriptElement = document.createElement('script');
  scriptElement.innerHTML = ` let h5RedirectMiniprogram = {
    init: function({
      appId, //小程序appId
      channel, //如果是推栏的小程序需要携带channel=jhdaily
      username, //小程序原始id,例如:gh_bb1a8b842018
      path, //小程序打开h5页面的路径,例如:pages/webview/index
      webviewUrlTag = 'redirectUrl', //小程序webview打开h5页面链接参数标识,例如:redirectUrl
      redirectUrl = window.location.href, //小程序webview打开的h5页面链接
      isMaster, //是否是正式环境,因为url-schema接口区分正式接口和测试接口
      envVersion ='release' //小程序环境版本 release:正式环境 trial:体验版
    } = {}) {
      //获取浏览器userAgent
      var userAgent = (navigator.userAgent || navigator.vendor || window.opera).toLowerCase();
      //判断是否在微信
      var isWeiXin = String(userAgent.match(/MicroMessenger/i)) === 'micromessenger';
      //判断是否在小程序
      var isMiniprogram = 'miniprogram' === window.__wxjs_environment || /miniProgram/i.test(userAgent);
      /**
       * 在微信内且不在小程序内时跳转中转页
       */
      if ( !isMiniprogram) {
        //中转页地址
        var pageUrl = isMaster
          ? '//xfe.seasungame.com/common-errors/browser-redierct-miniprogram/index.html'
          : '//test-zt.xoyo.com/xfe.seasungame.com/common-errors/browser-redierct-miniprogram/index.html';
        //中转页地址
        var finalPageUrl =
        pageUrl +
        '?appId=' +
        encodeURIComponent(appId) +
        '&channel=' +
        encodeURIComponent(channel) +
        '&username=' +
        encodeURIComponent(username) +
        '&path=' +
        encodeURIComponent(path) +
        '&webviewUrlTag=' +
        encodeURIComponent(webviewUrlTag) +
        '&redirectUrl=' +
        encodeURIComponent(redirectUrl) +
        '&isMaster=' +
        isMaster + 
        '&envVersion=' +
        envVersion;
        // console.log(finalPageUrl);
        window.location.href = finalPageUrl;
      }
    }
  };`;

  const scriptTag = document.createElement('script');
  scriptTag.innerHTML = `
    (function() {
       var url = '${redirectUrl}' ? '${redirectUrl}' : window.location.href;
       h5RedirectMiniprogram.init({appId:'${appId}',channel:'${channel}',username:'${username}',path:'${path}',webviewUrlTag:'${webviewUrlTag}',redirectUrl:url,isMaster:${isMaster},envVersion:'${envVersion}'});
    }());
  `;

  document.head.appendChild(scriptElement);
  document.head.appendChild(scriptTag);
}
